export default "__VITE_ASSET__CrBhoa5d__"